import React from "react";

const Benefits = () => {
  return (
    <div className="plp-benefits-wrapper">
      <h1>
        Benefits of <span>Product</span> Line Printing
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <p>Consistent, high-quality printing with minimal downtime</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <p>Enhanced branding through accurate and clear printing</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-4">
          <div className="card">
            <p>Customizable for different industries and products</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
